import { useState } from "react";
import {
  IconDeviceMobile,
  IconMessage2,
  IconBrandWhatsapp,
  IconQrcode,
} from "@tabler/icons-react";
import styles from "../../../../pages/ClientDashboard/Profile/profile.module.css";
import Button from "../../Button/button";
import Toggle from "../../Toggle/Toggle";

export default function TwoFactorCard({ onShowToast }) {
  const [whatsappEnabled, setWhatsappEnabled] = useState(false);
  const [whatsappPhone, setWhatsappPhone] = useState("");

  function handleWhatsappToggle(e) {
    const checked = e.target.checked;
    setWhatsappEnabled(checked);
    if (!checked) onShowToast("WhatsApp verification disabled");
  }

  function handleVerifyWhatsapp() {
    setWhatsappEnabled(false);
    onShowToast("Verification code sent to WhatsApp");
  }

  return (
    <div className={styles.card}>

      <div className={styles.cardBody}>

        {/* WhatsApp */}
        <div className={styles.tfaRow}>
          <div className={styles.tfaLeft}>
            <div
              className={styles.tfaIcon}
              style={{ background: "#e7fde8", color: "#25d366" }}
            >
              <IconBrandWhatsapp size={20} />
            </div>
            <div>
              <div className={styles.tfaDevice}>WhatsApp Verification</div>
              <div className={styles.tfaMeta}>
                Receive login codes via WhatsApp
              </div>
            </div>
          </div>
          <Toggle
            id="whatsappToggle"
            ariaLabel="Enable WhatsApp verification"
            checked={whatsappEnabled}
            onChange={handleWhatsappToggle}
          />
        </div>

        {whatsappEnabled && (
          <div className={styles.whatsappBox}>
            <p className={styles.whatsappBoxTitle}>
              <IconBrandWhatsapp size={15} /> Link your WhatsApp number
            </p>
            <div className={styles.whatsappBoxRow}>
              <div className={styles.phoneInputWrap} style={{ flex: 1 }}>
                <div className={styles.phoneFlag}>🇳🇬 +234</div>
                <input
                  type="tel"
                  placeholder="708 930 3820"
                  value={whatsappPhone}
                  onChange={(e) => setWhatsappPhone(e.target.value)}
                />
              </div>
              <button
                className={styles.whatsappSendBtn}
                onClick={handleVerifyWhatsapp}
              >
                Send Code
              </button>
            </div>
            <p className={styles.whatsappBoxHint}>
              A verification code will be sent to this WhatsApp number.
            </p>
          </div>
        )}

      </div>
    </div>
  );
}
